import { render, staticRenderFns } from "./qhhwTable.vue?vue&type=template&id=d96116c8&scoped=true"
import script from "./qhhwTable.vue?vue&type=script&lang=ts"
export * from "./qhhwTable.vue?vue&type=script&lang=ts"
import style0 from "./qhhwTable.vue?vue&type=style&index=0&id=d96116c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96116c8",
  null
  
)

export default component.exports